import { Component } from '@angular/core';
import { TestimonialsCarouselBaseComponent } from '../../common-theme/index';

@Component({
  selector: 'app-testimonials-carousel',
  templateUrl: './testimonials-carousel.component.html',
  styleUrls: ['./testimonials-carousel.component.scss']
})

export class TestimonialsCarouselComponent extends TestimonialsCarouselBaseComponent { }



// WEBPACK FOOTER //
// ./src/app/shared/testimonials-carousel/testimonials-carousel.component.ts